import React from 'react';
import { translate } from 'react-jhipster';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, IconButton } from '@mui/material';
import { Button, Col, Form, Input, Label, Row } from 'reactstrap';
import CloseIcon from '@mui/icons-material/Close';

// TODO refactor to reduce input params and move data into internal state where possible
export const ManualOrderDialog = ({
  openManualOrderDialog,
  maxWidth,
  isBidId,
  isOtcId,
  isStbId,
  quotationEntity,
  ecertBursaValue,
  setEcertBursaValue,
  ecertNumberError,
  purchaseCertError,
  transferCertError,
  sellCertError,
  purchaseFileName,
  transferFileName,
  sellFileName,
  fileUpload,
  handleUploadedPurchaseCert,
  handleUploadedTransferCert,
  handleUploadedSellCert,
  handleCloseManualOrderDialog,
  handleEcertInput,
  isSaveClick,
  labelStyle,
  inputStyle,
}) => {
  return (
    <Dialog open={openManualOrderDialog} maxWidth={maxWidth} fullWidth>
      <Form>
        <DialogTitle style={{ fontWeight: 'bold' }}>
          {isBidId === false && translate('comexApp.quotation.execute.executePurchase')}
          {isOtcId === false && quotationEntity?.status === 'Transferred' && translate('comexApp.quotation.execute.executeTransfer')}
          {isStbId === false && quotationEntity?.status === 'Sold' && translate('comexApp.quotation.execute.executeSell')}
          {((isBidId === true && quotationEntity?.bankCustomerApproval === false) ||
            (isOtcId === true && quotationEntity?.stbOption === null) ||
            isStbId === true) &&
            translate('comexApp.quotation.execute.editUploadedCert')}
        </DialogTitle>

        <DialogContent>
          <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton
              aria-label="close"
              onClick={handleCloseManualOrderDialog}
              sx={{
                position: 'absolute',
                top: 10,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>

          <Row className="justify-content-center">
            <div className="field-container">
              <label htmlFor="ecertNo">{translate('comexApp.quotation.executePurchase.ecertNumber')}</label>
              <Input
                name="ecertNo"
                id="ecertNo"
                type="text"
                value={quotationEntity?.bursaAPIBidCertId === null ? ecertBursaValue : quotationEntity?.bursaAPIBidCert?.ecertNo}
                disabled={quotationEntity?.bursaAPIBidCertId !== null}
                onChange={e => {
                  setEcertBursaValue(e.target.value);
                }}
              />
              <p hidden={ecertNumberError === false} style={{ color: 'red', fontWeight: 400, marginBottom: '0px', marginTop: '5px' }}>
                {translate('entity.validation.required')}
              </p>
            </div>
            <div
              hidden={
                (isOtcId === false && quotationEntity?.status === 'Transferred') ||
                (isStbId === false && quotationEntity?.status === 'Sold')
              }
            >
              <Label>{translate('comexApp.quotation.execute.uploadPurchaseCertificate')}</Label>
              <br />
              <label htmlFor="purchase-file-upload" style={labelStyle}>
                {translate('comexApp.quotation.uploadFile.btnUploadFile')}
              </label>
              &nbsp;
              <span>{purchaseFileName === '' ? translate('comexApp.quotation.uploadFile.noFileChoosen') : purchaseFileName}</span>
              <Input
                innerRef={fileUpload}
                type="file"
                accept=".pdf"
                id="purchase-file-upload"
                style={inputStyle}
                onChange={handleUploadedPurchaseCert}
              />
              <p
                hidden={
                  purchaseCertError === true ||
                  (isBidId === true && quotationEntity?.bankCustomerApproval === false) ||
                  (isOtcId === true && quotationEntity?.stbOption === null) ||
                  isStbId === true
                }
                className="mt-1 mb-0"
                style={{ color: 'red', fontWeight: 400 }}
              >
                {translate('entity.validation.required')}
              </p>
              &nbsp;
            </div>

            <div style={{ marginTop: '15px' }} hidden={isBidId === false || (isStbId === false && quotationEntity?.status === 'Sold')}>
              <Label>{translate('comexApp.quotation.execute.uploadTransferCertificate')}</Label>
              <br />
              <label
                htmlFor="transfer-file-upload"
                style={{
                  ...labelStyle,
                  color: quotationEntity?.status === 'Bought' ? 'gray' : 'black',
                  cursor: quotationEntity?.status === 'Bought' ? 'not-allowed' : 'pointer',
                }}
                onClick={e => {
                  if (quotationEntity?.status === 'Bought') e.preventDefault();
                }}
              >
                {translate('comexApp.quotation.uploadFile.btnUploadFile')}
              </label>
              &nbsp;
              <span>{transferFileName === '' ? translate('comexApp.quotation.uploadFile.noFileChoosen') : transferFileName}</span>
              <Input
                innerRef={fileUpload}
                type="file"
                accept=".pdf"
                id="transfer-file-upload"
                style={inputStyle}
                onChange={handleUploadedTransferCert}
                disabled={quotationEntity?.status === 'Bought'}
              />
              <p
                hidden={
                  transferCertError === true ||
                  (isBidId === true && quotationEntity?.bankCustomerApproval === false) ||
                  (isOtcId === true && quotationEntity?.stbOption === null) ||
                  isStbId === true
                }
                className="mt-1 mb-0"
                style={{ color: 'red', fontWeight: 400 }}
              >
                {translate('entity.validation.required')}
              </p>
              &nbsp;
            </div>
            <div
              style={{ marginTop: '15px' }}
              hidden={isBidId === false || (isOtcId === false && quotationEntity?.status === 'Transferred')}
            >
              <Label>{translate('comexApp.quotation.execute.uploadSellCertificate')}</Label>
              <br />
              <label
                htmlFor="sell-file-upload"
                style={{
                  ...labelStyle,
                  color: quotationEntity?.status === 'Bought' || quotationEntity?.status === 'Transferred' ? 'gray' : 'black',
                  cursor: quotationEntity?.status === 'Bought' || quotationEntity?.status === 'Transferred' ? 'not-allowed' : 'pointer',
                }}
                onClick={e => {
                  if (quotationEntity?.status === 'Bought' || quotationEntity?.status === 'Transferred') e.preventDefault();
                }}
              >
                {translate('comexApp.quotation.uploadFile.btnUploadFile')}
              </label>
              &nbsp;
              <span>{sellFileName === '' ? translate('comexApp.quotation.uploadFile.noFileChoosen') : sellFileName}</span>
              <Input
                innerRef={fileUpload}
                type="file"
                accept=".pdf"
                id="sell-file-upload"
                style={inputStyle}
                onChange={handleUploadedSellCert}
                disabled={quotationEntity?.status === 'Bought' || quotationEntity?.status === 'Transferred'}
              />
              <p
                hidden={
                  sellCertError === true ||
                  (isBidId === true && quotationEntity?.bankCustomerApproval === false) ||
                  (isOtcId === true && quotationEntity?.stbOption === null) ||
                  isStbId === true
                }
                className="mt-1 mb-0"
                style={{ color: 'red', fontWeight: 400 }}
              >
                {translate('entity.validation.required')}
              </p>
              &nbsp;
            </div>
          </Row>
        </DialogContent>
      </Form>
      <DialogActions className="mx-3 mb-3">
        <Button onClick={handleCloseManualOrderDialog}>{translate('comexApp.quotation.cancelBtnLabel')}</Button>
        &nbsp;
        <Button
          color="primary"
          type="submit"
          disabled={
            (isBidId === false && (purchaseCertError === false || ecertNumberError === true)) ||
            (isOtcId === false && quotationEntity?.status === 'Transferred' && transferCertError === false) ||
            (isStbId === false && quotationEntity?.status === 'Sold' && sellCertError === false) ||
            isSaveClick === true
          }
          onClick={handleEcertInput}
          autoFocus
        >
          {translate('comexApp.bank.details.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
